import React from "react";

import { CharacterTheme } from "@dndbeyond/character-rules-engine/es";

import BaseSvg from "../../BaseSvg";

interface Props {
  theme: CharacterTheme;
  className: string;
}
export default class InspirationBoxSvg extends React.PureComponent<Props> {
  static defaultProps = {
    className: "",
  };

  render() {
    const { theme, className } = this.props;

    let classNames: Array<string> = ["ddbc-inspiration-box-svg", className];

    return (
      <BaseSvg className={classNames.join(" ")} viewBox="0 0 72 54">
        <defs>
          <polygon
            id="InspirationBoxSvg-path-1"
            points="71.7300755 53.9993077 71.7300755 0.798923077 0.000275471698 0.798923077 0.000275471698 53.9993077"
          />
        </defs>
        <g
          id="InspirationBoxSvg-Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="InspirationBoxSvg-Sheet_Desktop_Static"
            transform="translate(-1484.000000, -280.000000)"
          >
            <g
              id="InspirationBoxSvg-Page-1"
              transform="translate(1484.000000, 280.000000)"
            >
              <polygon
                id="InspirationBoxSvg-Fill-1"
                fill={theme.backgroundColor}
                points="70 2 70 51 50.05556 51 42.7471616 47.5987134 29.2706337 47.5987134 21.9430711 51 2 51 2 2 21.3270795 2 27.9441984 6.34142368 44.0749658 6.34142368 50.6729205 2"
              />
              <g id="InspirationBoxSvg-Group-4">
                <g id="InspirationBoxSvg-Clip-3" />
                <path
                  d="M71.7303509,6.16223077 L71.7303509,0.798230769 L49.3978604,0.798230769 L48.9033887,1.42269231 C48.0728415,2.47223077 47.0508415,3.29746154 45.9186528,3.88592308 C43.1198604,2.67438462 40.1668038,1.99176923 37.1848226,1.83392308 C36.9492943,1.33407692 36.4534453,0.979615385 35.8639358,0.979615385 C35.2771811,0.979615385 34.7785774,1.33407692 34.5458038,1.83392308 C31.5624453,1.99176923 28.6121434,2.67438462 25.8133509,3.88592308 C24.6797849,3.29746154 23.6577849,2.47223077 22.8286151,1.42269231 L22.3341434,0.798230769 L0.000275471698,0.798230769 L0.000275471698,53.9993077 L22.3341434,53.9993077 L22.8286151,53.3762308 C23.6577849,52.3280769 24.6770302,51.5000769 25.8092189,50.9143846 C28.6025019,52.1300769 31.530766,52.8223846 34.5526906,52.9774615 C34.7909736,53.4703846 35.2826906,53.8179231 35.8639358,53.8179231 C36.4451811,53.8179231 36.9396528,53.4703846 37.1751811,52.9774615 C40.1998604,52.8223846 43.1295019,52.1300769 45.9227849,50.9143846 C47.0522189,51.5000769 48.0742189,52.3280769 48.9033887,53.3762308 L49.3978604,53.9993077 L71.7303509,53.9993077 L71.7303509,48.6366923 L71.7303509,6.16223077 Z M71.7303509,11.4348462 L71.7303509,8.76253846 L71.7303509,11.4348462 Z M34.6546151,3.23238462 C34.9121811,3.63946154 35.3474264,3.92330769 35.8639358,3.92330769 C36.3832,3.92330769 36.8156906,3.63946154 37.0773887,3.23238462 C39.4230302,3.35146154 41.7452566,3.81253846 43.9793321,4.61976923 C43.2934075,4.79007692 42.5854453,4.88284615 41.8692189,4.88284615 L29.8627849,4.88284615 C29.1424264,4.88284615 28.4372189,4.79007692 27.7540491,4.61976923 C29.9853698,3.81253846 32.3089736,3.35146154 34.6546151,3.23238462 L34.6546151,3.23238462 Z M37.0760113,51.5651538 C36.8143132,51.1594615 36.3818226,50.8728462 35.8639358,50.8728462 C35.3474264,50.8728462 34.9149358,51.1594615 34.6573698,51.5651538 C32.3089736,51.4474615 29.9853698,50.9863846 27.7540491,50.1763846 C28.4372189,50.0074615 29.1424264,49.9146923 29.8627849,49.9146923 L41.8692189,49.9146923 C42.5854453,49.9146923 43.2934075,50.0074615 43.9793321,50.1763846 C41.7452566,50.9863846 39.4202755,51.4474615 37.0760113,51.5651538 L37.0760113,51.5651538 Z M50.9515208,50.6914615 C48.6058792,48.0856154 45.3374075,46.6054615 41.8692189,46.6054615 L29.8627849,46.6054615 C26.3932189,46.6054615 23.1261245,48.0856154 20.780483,50.6914615 L18.5918604,50.6914615 C18.5918604,50.6914615 3.29078491,50.6291538 3.29078491,42.6537692 L3.29078491,12.1437692 C3.29078491,4.167 18.5918604,4.10746154 18.5918604,4.10746154 L20.780483,4.10746154 C23.1261245,6.71192308 26.3932189,8.19069231 29.8627849,8.19069231 L41.8692189,8.19069231 C45.3374075,8.19069231 48.6058792,6.71192308 50.9515208,4.10746154 L53.138766,4.10746154 C53.138766,4.10746154 68.4384642,4.167 68.4384642,12.1437692 L68.4384642,42.6537692 C68.4384642,50.6291538 53.138766,50.6914615 53.138766,50.6914615 L50.9515208,50.6914615 Z M71.7303509,46.0363846 L71.7303509,43.3626923 L71.7303509,46.0363846 Z"
                  id="InspirationBoxSvg-Fill-2"
                  fill={theme.themeColor}
                />
              </g>
            </g>
          </g>
        </g>
      </BaseSvg>
    );
  }
}
